export default "__VITE_ASSET__bc1d6fff__"